<template>
  <div>
    <br />
    <div
      class="col-md-12 card"
      v-show="opcion == 1"
      style="border-radius: 20px; padding-left: 7%; padding-right: 7%"
    >
      <div class="card-content">
        <div class="col-md-12">
          <center>
            <h4 class="title" style="margin-top: 10px; color: grey">
              <i class="fa fa-search"></i> Buscar Historia Clínica
            </h4>
          </center>
        </div>
        <br />
        <form @submit.prevent="buscarPacientes()">
          <br />
          <br />
          <br />
          <div class="row">
            <div class="col-12 col-xs-12 col-md-4">
              <br />
              <select name v-model="criterio" class="form-control">
                <option value="paciente.PacApe1">
                  <i class="fa fa-user"></i> Apellidos del paciente
                </option>
                <option value="paciente.PacNom1">Nombres del paciente</option>
                <option value="paciente.PacNumDoc">
                  Documento del paciente
                </option>
              </select>
            </div>
            <div class="col-12 col-xs-12 col-md-6">
              <br />
              <input
                required
                type="text"
                id="texto"
                name="texto"
                v-model="busqueda"
                class="form-control"
                placeholder="Buscar..."
              />
            </div>

            <div class="col-12 col-xs-12 col-md-2">
              <br />
              <button
                type="submit"
                style="border-radius: 5px"
                class="btn btn-block btn-success btn-fill"
              >
                <i class="fa fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-md-1"></div>
          </div>
        </form>
      </div>
      <br />
      <div class="card-content" v-if="pacientes != ''">
        <center>
          <el-table
            size="mini"
            class="
              el-table
              table-striped
              el-table--fit
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            :data="pacientes"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="PacNom1" label="Nombres"></el-table-column>
            <el-table-column prop="PacApe1" label="Apellidos"></el-table-column>
            <el-table-column
              prop="PacNumDoc"
              label="Documento"
            ></el-table-column>
            <el-table-column width="50">
              <template slot-scope="props">
                <a
                  class="btn btn-simple btn-icon btn-success"
                  @click="llamarPacientes(props.row)"
                >
                  <i class="fa fa-search"></i>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </center>
      </div>
      <center v-else>
        <br />
        <br />
        <div class="row" style="width: 80%">
          <div class="alert alert-danger alert-with-icon">
            <center>
              <img src="static/img/logo.webp" style="width: 20%" alt />
              <br />
              <br />
              <!-- <span data-notify="icon" class="fa fa-info"></span> -->
              <strong data-notify="message" style="color: white">
                <i :class="'fa fa-' + icono"></i>
                {{ mensaje }}
              </strong>
              <br />
              <br />
            </center>
          </div>
        </div>
      </center>

      <br />
    </div>

    <div class="col-md-12 card" v-show="opcion == 2">
      <button class="btn btn-simple btn-icon" @click="cerrarHC()">
        <i
          class="fa fa-arrow-circle-o-left"
          style="font-size: 23px; color: #b3b3b3; float: left"
        ></i>
      </button>
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <strong style="font-size: 18px"
              >Historia Clínica </strong
            ><br />
            <p>Paciente: <strong>{{ nombres }}
              {{ apellidos }}</strong></p>
            <p>
              Diagnóstico: 
              {{ diagnosticoPaciente == null ? 'Sin diagnóstico' : diagnosticoPaciente }} 
              <button class="btn btn-icon btn-success btn-sm" @click="prepararEditDX(diagnosticoPaciente)">Actualizar diagnóstico</button><br />
            </p>
            <strong style="font-size: 12px; color: red" v-if="estado == 0"
              >INACTIVO</strong
            >
            <strong style="font-size: 12px; color: green" v-if="estado == 1"
              >ACTIVO</strong
            >
            <br />
            <strong
              style="font-size: 12px"
              v-if="loked != null"
              class="text-secondary"
              >CONFIDENCIAL</strong
            >
          </div>
          <div class="col-md-6">
            <button
              class="btn btn-success btn-fill btn-primary"
              style="float: right; border-radius: 5px"
              type="button"
              @click="informacion = true"
              v-if="informacion == false"
            >
              <i class="fa fa-arrow-down"></i> Información del paciente
            </button>
            <button
              class="btn btn-success"
              style="float: right; border-radius: 5px"
              @click="informacion = false"
              v-else
            >
              <i class="fa fa-arrow-up"></i> Ocultar información
            </button>
          </div>
          <div class="col-md-12">
            <br />
            <button
              @click="push('/diarioCampo/objetivos-y-logros')"
              class="btn btn-success"
              style="border-radius: 5px"
            >
              Ir a objetivos y logros <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <br />
      <div class="card-content">
        <br />
        <div class="card-informacion" v-show="informacion">
          <div
            class="row"
            style="
              background-color: #f5f5f5;
              border-radius: 20px;
              padding: 15px;
            "
          >
            <div class="col-md-10">
              <br />
              <div class="row">
                <div class="col-md-6">
                  <label
                    ><small>Nombre completo:</small> {{ nombres }}
                    {{ apellidos }}</label
                  >
                </div>
                <div class="col-md-6">
                  <label
                    ><small>Número de documento:</small>
                    {{ numeroDocumento }}</label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label
                    ><small>Fecha de ingreso:</small>
                    {{ fechaIngreso | date }}</label
                  >
                </div>
                <div class="col-md-6">
                  <label
                    ><small>Fecha de nacimiento:</small>
                    {{ Fecha_nacimiento | date }}</label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label><small>Sexo:</small> {{ sexo }}</label>
                </div>
                <div class="col-md-6">
                  <label
                    ><small>Edad: </small>{{ anos }} Años y
                    {{ meses }} Meses</label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label><small>EPS:</small> {{ eps }}</label>
                </div>
                <div class="col-md-6">
                  <label><small>Régimen:</small> {{ regimen }}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label><small>Prepagada:</small> {{ prepagada }}</label>
                </div>
                <div class="col-md-6">
                  <label><small>Póliza:</small> {{ poliza }}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label
                    ><small>Tipo de afiliación:</small>
                    {{ tipoAfiliacion }}</label
                  >
                </div>
              </div>
              <br />
            </div>

            <div class="col-md-2">
              <div class="image">
                <img
                  style="border-radius: 15px !important"
                  width="130"
                  :src="ip + '' + fotoPaciente"
                />
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <vue-tabs
          class="row"
          direction="horizontal"
        >
          <v-tab title="Motivo de consulta">
            <template slot="title">
              <p>
                <i
                  v-if="motivoConsultaHoy == false"
                  class="fa fa-close texto_rojo"
                ></i>
                <i v-else class="ti ti-check texto_verde"></i>
                Motivo Consulta Verificado
              </p>
            </template>
            <div class="col-md-12 col-xs-5"></div>

            <center>
              <h4 style="margin: 0px; margin-top: -3px">
                Motivos de consulta
                <span class="badge badge-success">{{
                  arrayMotivo.length
                }}</span>
              </h4>
              <div>
                <button
                  @click="abrirModalAgregar()"
                  type="button"
                  style="float: left; margin-bottom: 15px"
                  class="btn btn-success btn-fill"
                  v-if="estado == 1"
                >
                   Nuevo motivo de consulta <i class="fa fa-plus"></i>
                </button>
              </div>
              <br />
              <el-table
                class="table-striped table-sm"
                border
                :data="arrayMotivo"
                v-if="arrayMotivo != ''"
                max-height="500"
                style="width: 100%"
              >
                <!-- <el-table-column label="#" type="index"></el-table-column> -->
                <el-table-column label="Fecha" width="140">
                  <template slot-scope="props">{{ props.row.MotFec }}</template>
                </el-table-column>
                <el-table-column
                  prop="MotDes"
                  label="Motivo de consulta"
                ></el-table-column>
                <el-table-column
                  prop="MotTer"
                  width="135"
                  label="Terapeuta"
                ></el-table-column>
                <el-table-column label="Estado" width="135">
                  <template slot-scope="props">
                    <div v-if="props.row.MotEst == 0">
                      <span slot="title-label" class="label label-warning">
                        <i class="ti-close"></i> Por verificar
                      </span>
                    </div>
                    <div v-if="props.row.MotEst == 1">
                      <span slot="title-label" class="label label-info">
                        <i class="ti-check"></i> Verificado
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Acciones" width="85">
                  <template slot-scope="props">
                    <center>
                      <a
                        v-if="props.row.MotEst == 0"
                        class="btn btn-simple btn-warning btn-xs"
                        @click="motivoVerificar(props.row)"
                        data-target="#modalMotivoV"
                      >
                        <i class="ti-check"></i>
                      </a>

                      <a
                        v-else
                        class="btn btn-simple btn-warning btn-xs"
                        @click="motivoVerificar(props.row)"
                        data-toggle="modal"
                        data-target="#modalMotivoV2"
                      >
                        <i class="ti-eye"></i>
                      </a>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
            </center>
          </v-tab>
          <v-tab title="Antecedentes">
            <template slot="title">
              <p>
                <i
                  v-if="antecedenteHoy == false"
                  class="fa fa-close texto_rojo"
                ></i>
                <i v-else class="ti ti-check texto_verde"></i>
                Antecedentes
              </p>
            </template>
            <h4>ANTECEDENTES</h4>
            <vue-tabs direction="vertical" value="l">
              <v-tab
                :title="
                  'Prenatales' + '  ' + '( ' + antecedentesPre.length + ' )'
                "
              >
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill btn-block"
                      @click="abrirModalAntecedente(1)"
                      v-if="estado == 1"
                    >
                      Nuevo antecedente prenatal <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br />
                <el-table
                  class="table-striped table-sm"
                  border
                  :data="antecedentesPre"
                  max-height="500"
                  v-if="antecedentesPre != ''"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <!-- <el-table-column label="tipo" width="185">
                    <template slot-scope="props">
                     
                        <p>Prenatales</p>
                        <p v-if="props.row.AntTip == 2">Neonatales</p>
                        <p v-if="props.row.AntTip == 3">Postnatales</p>
                        <p v-if="props.row.AntTip == 4">Personales</p>
                        <p v-if="props.row.AntTip == 5">Familiares</p>
                     
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </v-tab>
              <v-tab
                :title="
                  'Perinatales' + ' ' + '( ' + antecedentesNeo.length + ' )'
                "
              >
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill btn-block"
                      v-if="estado == 1"
                      @click="abrirModalAntecedente(2)"
                    >
                      Nuevo antecedente perinatal <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br />
                <el-table
                  class="table-striped table-sm"
                  border
                  :data="antecedentesNeo"
                  max-height="330"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <!-- <el-table-column label="tipo" width="185">
                    <template slot-scope="props">
                     
                        <p v-if="props.row.AntTip == 1">Prenatales</p>
                        <p v-if="props.row.AntTip == 2">Neonatales</p>
                        <p v-if="props.row.AntTip == 3">Postnatales</p>
                        <p v-if="props.row.AntTip == 4">Personales</p>
                        <p v-if="props.row.AntTip == 5">Familiares</p>
                     
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </v-tab>
              <v-tab :title="'Postnatales ( ' + antecedentesPos.length + ' )'">
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill btn-block"
                      @click="abrirModalAntecedente(3)"
                      v-if="estado == 1"
                    >
                      Nuevo antecedente posnatal <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br />
                <el-table
                  class="table-striped table-sm"
                  border
                  :data="antecedentesPos"
                  max-height="500"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <!-- <el-table-column label="tipo" width="185">
                    <template slot-scope="props">
                      
                        <p v-if="props.row.AntTip == 1">Prenatales</p>
                        <p v-if="props.row.AntTip == 2">Neonatales</p>
                        <p v-if="props.row.AntTip == 3">Postnatales</p>
                        <p v-if="props.row.AntTip == 4">Personales</p>
                        <p v-if="props.row.AntTip == 5">Familiares</p>
                      
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </v-tab>
              <v-tab :title="'Personales ( ' + antecedentesPer.length + ' )'">
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill btn-block"
                      @click="abrirModalAntecedente(4)"
                      v-if="estado == 1"
                    >
                      Nuevo antecedente personal <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br />
                <el-table
                  class="table-striped table-sm"
                  border
                  :data="antecedentesPer"
                  max-height="330"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <!-- <el-table-column label="tipo" width="185">
                    <template slot-scope="props">
                     
                        <p v-if="props.row.AntTip == 1">Prenatales</p>
                        <p v-if="props.row.AntTip == 2">Neonatales</p>
                        <p v-if="props.row.AntTip == 3">Postnatales</p>
                        <p v-if="props.row.AntTip == 4">Personales</p>
                        <p v-if="props.row.AntTip == 5">Familiares</p>
                     
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </v-tab>
              <v-tab :title="'Familiares ( ' + antecedentesFam.length + ' )'">
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill btn-block"
                      @click="abrirModalAntecedente(5)"
                      v-if="estado == 1"
                    >
                      Nuevo antecedente familiar <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br />
                <el-table
                  class="table-striped table-sm"
                  border
                  :data="antecedentesFam"
                  max-height="500"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <!-- <el-table-column label="tipo" width="185">
                    <template slot-scope="props">
                     
                        <p v-if="props.row.AntTip == 1">Prenatales</p>
                        <p v-if="props.row.AntTip == 2">Neonatales</p>
                        <p v-if="props.row.AntTip == 3">Postnatales</p>
                        <p v-if="props.row.AntTip == 4">Personales</p>
                        <p v-if="props.row.AntTip == 5">Familiares</p>
                     
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </v-tab>
            </vue-tabs>
          </v-tab>
          <v-tab title="Impresión General">
            <template slot="title">
              <p>
                <i
                  v-if="impresionHoy == false"
                  class="fa fa-close texto_rojo"
                ></i>
                <i v-else class="ti ti-check texto_verde"></i>
                Impresión General
              </p>
            </template>
            <center>
              <h4 style="margin: 0px; margin-top: -3px">
                Impresión general
                <span class="badge badge-success">{{
                  arrayResumen.length
                }}</span>
              </h4>
            </center>

            <button
              @click="abriModalAnamnesis()"
              type="button"
              style="float: left; margin-bottom: 5px; border-radius:5px; margin-top:15px;"
              class="btn btn-success btn-fill"
              v-if="estado == 1"
            >
              <i class="fa fa-plus"></i> Nueva observación
            </button>

            <br /> <br>
            <el-table
              style="margin-top: 30px"
              max-height="500"
              class="
                el-table
                table-striped
                el-table--fit
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
              border
              :data="arrayResumen"
            >
              <el-table-column
                label="#"
                width="70"
                type="index"
              ></el-table-column>
              <el-table-column label="Fecha" width="120">
                <template slot-scope="props">
                  {{ props.row.ResFec }}
                </template>
              </el-table-column>
              <el-table-column
                prop="terapeuta"
                label="Terapeuta"
                width="130"
              ></el-table-column>
              <el-table-column
                prop="ResDes"
                label="Descripción"
              ></el-table-column>
              <!-- <el-table -column prop="ResCon" label="Conclusiones" width="300"></el-table-column> -->

              <!-- <el-table-column label="Acciones" width="85">
                <template slot-scope="props">
                  <center>
                    <a
                      class="btn btn-simple btn-icon btn-xs"
                      style="color:grey"
                      @click="detalleResumen(props.row)"
                      data-toggle="modal"
                      data-target="modaldetalleResumen"
                    >
                      <i class="ti-eye"></i>
                    </a>
                  </center>
                </template>
              </el-table-column>-->
            </el-table>
          </v-tab>

          <v-tab title="Examen Paciente">
            <template slot="title">
              <p>
                <i v-if="examenHoy == false" class="fa fa-close texto_rojo"></i>
                <i v-else class="ti ti-check texto_verde"></i>
                Examen Paciente
              </p>
            </template>
            <center>
              <strong style="color: grey; font-size: 18px">
                <i class="fa fa-filter"></i> Seleccione el exámen
              </strong>
            </center>
            <br />
            <div class="col-md-3"></div>
             <div class="row">
            <div class="col-md-6">
              <select
                @change="tipoExamen()"
                v-model="examen"
                class="form-control"
              >
                <option value="0">Seleccionar...</option>
                <option value="1">
                  Formato de evaluación de terapia ocupacional (AVANZA)
                </option>
                <option value="2">
                  Formato de evaluación psicología niños
                </option>
                <option value="3">
                  Formato de evaluación fonoaudiólogia función oral faringea
                </option>
                <option value="4">
                  Formato de evaluación fonoaudiólogia lenguaje
                </option>
                <option value="5">
                  Examen fisico basado en neurodesarrollo (AVANZA)
                </option>
                <option value="6">
                  Evaluación de la desorganización postural
                </option>
                <option value="7">
                  Formato de evaluación musculoesquelética
                </option>
                <option value="8" disabled>Psicología adulto</option>
                <option value="9" disabled>Evaluación cognitiva</option>
                <option value="10" disabled>Evaluación comportamental</option>
                <option value="11" disabled>Revisión por sistemas</option>
                <option value="12" disabled>Actualización historia clínica</option>
                <option value="13">Desempeño ocupacional</option>
                <option value="14">EAT. 1O</option>
                <option value="15">Formato miofuncional</option>
                <option value="16">Formato conductual niños</option>
                <option value="17">Formato psicoterapia adultos</option>
                <option value="18">Formato RH niños</option>
                <option value="19">Formato rehabilitación Cog. Adultos</option>
                <option value="20">Formato test articular</option>
                <option value="21">Formato test lectoescritura</option>
              </select>
              <br>
              <br>
            </div>
            <div class="col-md-2">
                    <a
                      v-if="link_examen_selecte!='#' && examen != 0"
                      :href="link_examen_selecte"
                      class="btn btn-secondary btn-fill"
                      style="border-radius: 5px"
                      target="_blank"
                    >
                      <i class="fa fa-download"></i> Descargar formato</a
                    >
                  </div>
            </div>
            


            <div class="row">
              <div class="" v-if="examen != 0">
                <div class="">
                  <div class="col-md-5">
                    <center>
                      <input
                        v-if="estado == 1"
                        type="file"
                        class="form-control"
                        id="examen1"
                        @change="cargarExamen"
                      />
                    </center>
                  </div>
                  <div class="col-md-2">
                    <button
                      class="btn btn-success btn-fill"
                      @click="agregarExamen()"
                      style="border-radius: 5px"
                      v-if="estado == 1"
                    >
                      <i class="fa fa-save"></i> Guardar examen
                    </button>
                  </div>
                  
                  <!-- <div class="col-md-3">
                    <span v-if="link_examen_selecte!='#'"
                      >Para acceder al formato deberás ingresar con tu correo de
                      <span style="color: blue">avanzaips.org</span></span
                    >
                  </div> -->

                </div>

               
                
              </div>

            </div>
            <div class="row">
                    <br>
                    <div class="col-md-12">
                     
                      <button
                        @click="examenes()"
                        style="border-radius: 5px; float: left"
                        class="btn btn-success btn-sm btn-fill"
                      >
                        Actualizar examenes
                      </button>
                     
                    </div>
                    <div class="col-md-12">
                      <el-table
                      class="table-striped"
                      border
                      v-if="examen != 0"
                      style="margin-top: 12px;"
                      :data="arrayActivo"
                    >
                      <el-table-column type="index"></el-table-column>
                      <el-table-column prop="created_at" label="Fecha y Hora">
                        <template slot-scope="props">
                          <div>{{ props.row.created_at }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="terapeuta"
                        label="Terapeuta"
                      ></el-table-column>
                      <el-table-column label="Ver Examen">
                        <template slot-scope="props">
                          <a
                            class="btn btn-simple btn-icon btn-xs"
                            style="color: grey"
                            target="_blank"
                            :href="ip + '' + props.row.ExaUrl"
                          >
                            <i class="ti-eye"></i>
                          </a>
                        </template>
                      </el-table-column>
                    </el-table>
                    </div>
            </div>
          </v-tab>
          <v-tab title="Conclusiones, Recomendación Y Plan De Tto">
            <template slot="title">
              <p>
                <i
                  v-if="tratamientoHoy == false"
                  class="fa fa-close texto_rojo"
                ></i>
                <i v-else class="ti ti-check texto_verde"></i>
                Conclusiones, Recomendación Y Plan De Tto
              </p>
            </template>
            <center>
              <h4 style="margin: 0px; margin-top: -3px">
                Conclusiones, recomendación y plan de Tto
                <span class="badge badge-success">{{
                  tratamiento.length
                }}</span>
              </h4>
            </center>

            <br> <br>
            <button
              @click="abriModalNuevoPlan()"
              type="button"
              style="float: left; margin-bottom: 5px; border-radius:5px;"
              class="btn btn-success btn-fill"
              
            >
              Nuevo plan de tratamiento <i class="fa fa-plus"></i>
            </button>

            <br /> <br>
            <el-table class="table-striped" :data="tratamiento" border  style="margin-top:15px;">
              <!-- <el-table-column label="#" type="index"></el-table-column> -->
              <el-table-column label="Fecha inicial" width="100">
                <template slot-scope="props">{{ props.row.TraFec }}</template>
              </el-table-column>
              <el-table-column label="Fecha Fin" width="100">
                <template slot-scope="props">
                  <p v-if="props.row.TraFecFin == null">Indefinido</p>
                  <p v-else>{{ props.row.TraFecFin }}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="terapeuta"
                label="Terapeuta"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="TraDes"
                label="Observaciones"
              ></el-table-column>
              <el-table-column width="90" label="Detalle">
                <template slot-scope="props">
                  <center>
                    <button
                      class="btn btn-simple btn-icon btn-xs"
                      style="color: grey"
                      title="Informe de evaluación"
                      @click="verDetalle(props.row)"
                    >
                      <i class="ti-eye"></i>
                    </button>

                    <!-- <button
                      v-if="props.row.terapeuta == usuarioAvanza"
                      @click="
                        prepararEditDX(props.row.TraCas, props.row.TraIde)
                      "
                      title="Editar DX"
                      class="btn btn-simple btn-success btn-icon btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>

                    <button
                      v-else
                      disabled
                      title="No puedes editar este DX"
                      class="btn btn-simple btn-success btn-icon btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button> -->
                  </center>
                </template>
              </el-table-column>
            </el-table>
          </v-tab>
          <v-tab title="Plan Intervención Terapéutica">
            <div class="row">
              <div class="col-md-4">
                <!-- <label for="">Fecha inicial:</label> -->
                <input type="date" v-model="fechaInicialEvoluciones" class="form-control" />
              </div>
              <div class="col-md-4">
                <!-- <label for="">Fecha final:</label> -->
                <input type="date" v-model="fechaFinalEvoluciones" class="form-control" />
              </div>
              <div class="col-md-3">
                <button @click="getEvoluciones(PacIde)" class="btn btn-success pull-left">Consultar información</button>
              </div>
            </div>
            <div class="card-content p-4 table-responsive table-full-width">

              <el-table
                class="table-striped"
                max-height="500"
                border
                :data="evoluciones"
              >
                <!-- <el-table-column label="Id" property="id"></el-table-column> -->
                <el-table-column
                  label="Terapeuta"
                  prop="EvoTer"
                  width="200"
                ></el-table-column>
                <el-table-column
                  label="Evolución"
                  width="520"
                  prop="Obs"
                ></el-table-column>
                <el-table-column label="Est. terapéutica">
                  <template slot-scope="props">
                    <p
                      style="font-size: 12px"
                      v-if="
                        props.row.Obs == 'Se hizo una evaluación del paciente'
                      "
                    >
                      Evaluación
                    </p>
                    <p v-else style="font-size: 12px">
                      {{ props.row.EvoEst }}
                    </p>
                  </template></el-table-column
                >
                <!-- <el-table-column label="Mat. de apoyo">
                  <template slot-scope="props">
                    <p
                      style="font-size: 12px"
                      v-if="
                        props.row.Obs == 'Se hizo una evaluación del paciente'
                      "
                    ></p>
                    <p v-else style="font-size: 12px">
                      {{ props.row.EvoMat }}
                    </p>
                  </template></el-table-column
                > -->
                <el-table-column label="Fecha" prop="EvoFec"></el-table-column>
              </el-table>
            </div>
          </v-tab>
        </vue-tabs>
        <!-- <div v-else>
          <div class="row">
            <div class="col-md-12">
              <center>
                <br />
                <br />
                <img
                  src="static/img/ICONOS/candado.svg"
                  class="img-responsive"
                  width="70"
                  alt="Imagen de bloqueo de HC avanti"
                />
                <br />
                <span
                  >Esta HC es confidencial. Por favor comunicarse con el
                  administrador para solicitar acceso.</span
                >
              </center>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- MODAL: verificar firma electronica -->

    <modal name="modalVerificarFirmaElectronica" width="500" height="auto" persistent="true">
      <div class="modal-header" style="padding:8px">
        <div class="row">
          <div class="col-md-10">Verificar firma electronica</div>
        </div>
      </div>
      <div class="modal-body" style="padding:10px;">
        <div class="row">
          <div class="col-md-12">
            <p> <span style="font-weight: 600;">Digita tu firma electronica!</span> <br>
            Verifica la firma electronica para validar los registros que hagas en la historia clinica de los pacientes.</p>
          </div>
            <div class="col-md-12">
              <p style="font-size: 12px;">
                <span style="font-weight: 600;">Recuerda:</span> <br>
                <span>La firma electronica es de uso personal, recomendarlos no guardarla en el navegador.</span>
              </p>
            </div>
          <div class="col-md-12">
            <input type="password" v-model="inputFirma" placeholder="********" class="form-control">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-success" @click="verificarFirmaElectronica()">Verificar firma</button>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal actualizar diagnostico -->
     <modal name="modalActualizarDiagnostico" width="500" height="auto">
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-check"></i>
          </div>
          <div class="col-md-9">
            <p class="titulo-modal">ACTUALIZAR DIAGNOSTICO</p>
            <p class="texto-pequeno">Actualizar diagnóstico</p>
          </div>
        </div>
      </div>
      <div class="modal-body">

      </div>

     </modal>
     
    <!-- MODAL NUEVO MOTIVO DE CONSULTA -->
    <div>
      <modal name="modalAgregar" width="500" height="auto">
        <form @submit.prevent="nuevoMotivoConsultaVerificado()">
          <div class="modal-header" style="padding: 8px">
            <div class="row">
              <div class="col-md-1">
                <i v-if="e_motivo == true" class="fa fa-file"></i>
                <i
                  v-if="e_motivo == false"
                  style="font-size: 37px !important"
                  class="fa fa-spinner"
                ></i>
              </div>
              <div class="col-md-7">
                <p v-if="e_motivo == true" class="titulo-modal">
                  NUEVO MOTIVO DE CONSULTA
                </p>
                <p v-if="e_motivo == false" class="titulo-modal">
                  ENVIANDO INFORMACIÓN
                </p>
                <p class="texto-pequeno">Motivo de consulta verificado</p>
              </div>
            </div>
          </div>
          <div class="modal-body scroll-gg">
            <label for>Fecha de la consulta:</label>
            <input
              type="date"
              v-model="fechaDeConsulta"
              disabled
              class="form-control select-sm"
            />
            <br />
            <div class>
              <label for>Motivo de la consulta:</label>
              <textarea
                class="form-control"
                v-model="motivosConsulta"
                required
                id
                maxlength="500"
                cols="20"
                rows="6"
              ></textarea>
              <br />
              <el-select
                :multiple="true"
                class="select-default"
                size="large"
                max-height="350"
                style="width: 100%"
                v-model="tmconsulta"
                placeholder="Seleccione..."
                required
              >
                <el-option
                  class="select-default"
                  v-for="option in optionsArray"
                  :value="option.DomDes"
                  :label="option.DomDes"
                  :key="option.DomDes"
                  >{{ option.DomDes }}</el-option
                >
              </el-select>
              <br />
              <br />

              <label for>Observaciones:</label>
              <textarea
                name
                v-model="consultaVerificada"
                required
                class="form-control"
                cols="30"
                rows="6"
                maxlength="500"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="cerrarModalMotivo()"
            >
              <i class="fa fa-close"></i> Cancelar
            </button>
            <!-- <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button> -->
            <button
              type="submit"
              v-if="e_motivo == true"
              data-dismiss="modal"
              class="btn btn-success btn-fill"
            >
              Guardar  <i class="fa fa-plus"></i>
            </button>
            <button
              type="button"
              v-if="e_motivo == false"
              disabled
              data-dismiss="modal"
              class="btn btn-success btn-sm"
            >
              <i class="fa fa-spinner"></i> Guardando...
            </button>
          </div>
        </form>
      </modal>
    </div>
    <!-- FIN DEL MODAL DE NUEVO MOTIVO DE CONSULTA -->
    <!-- modal verificado -->

    <modal
      name="modalDetallesMC"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      width="500"
      height="auto"
      :draggable="true"
    >
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-file"></i>
          </div>
          <div class="col-md-9">
            <p class="titulo-modal">VER DETALLES DEL MOTIVO DE CONSULTA</p>
            <p class="texto-pequeno">Motivo detallado</p>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <label for>Fecha de la consulta:</label>
        <input
          type="date"
          disabled
          v-model="motivoVerificarFec"
          class="form-control"
        />

        <label for>Motivo de la consulta:</label>
        <textarea
          class="form-control"
          disabled
          v-model="motivoVerificarDes"
          id
          cols="30"
          rows="3"
        ></textarea>
        <br />

        <input
          type="date"
          disabled
          v-model="fechaVerificado"
          class="form-control"
        />
        <br />
        <div>
          <el-select
            disabled
            multiple
            class="select-default"
            size="large"
            style="width: 100%; color: white"
            v-model="tmconsulta"
            placeholder="Seleccione..."
          >
            <el-option
              v-for="option in optionsArray"
              class="select-default"
              :value="option.DomDes"
              :label="option.DomDes"
              :key="option.DomId"
            ></el-option>
          </el-select>
        </div>
        <br />

        <textarea
          name
          disabled
          v-model="consultaVerificada"
          class="form-control"
          cols="30"
          rows="3"
        ></textarea>

        <br />
      </div>
      <div class="modal-footer"></div>
    </modal>
    <!-- modal verificado -->
    <!-- verificar motivo -->

    <modal
      name="modalVerificarMC"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      width="500"
      height="auto"
      :draggable="true"
    >
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-check"></i>
          </div>
          <div class="col-md-9">
            <p class="titulo-modal">VERIFICAR MOTIVO DE CONSULTA</p>
            <p class="texto-pequeno">Verificación del motivo de consulta</p>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <label for>Fecha de la consulta:</label>
        <input
          type="date"
          disabled
          v-model="motivoVerificarFec"
          class="form-control"
        />

        <label for>Motivo de la consulta:</label>
        <textarea
          class="form-control"
          disabled
          v-model="motivoVerificarDes"
          id
          cols="30"
          rows="3"
        ></textarea>
        <br />
        <br />

        <input
          type="date"
          disabled
          v-model="fechaVerificado"
          class="form-control"
        />
        <br />
        <div>
          <el-select
            multiple
            class="select-default"
            size="large"
            style="width: 100%; color: white"
            v-model="tmconsulta"
            placeholder="Seleccione..."
          >
            <el-option
              v-for="option in optionsArray"
              class="select-default"
              :value="option.DomDes"
              :label="option.DomDes"
              :key="option.DomDes"
            ></el-option>
          </el-select>
        </div>
        <br />
        <label for>Observaciones:</label>
        <textarea
          name
          v-model="consultaVerificada"
          class="form-control"
          cols="30"
          rows="3"
        ></textarea>

        <br />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          data-dismiss="modal"
          @click="cerrarModalMotivoVerificar()"
        >
          <i class="fa fa-close"></i> Cancelar
        </button>
        <button
          type="button"
          @click="verificarMotivo()"
          data-dismiss="modal"
          class="btn btn-success"
        >
          Guardar <i class="fa fa-plus"></i>
        </button>
      </div>
    </modal>

    <!-- fin verificar motivo -->

    <!-- nuevo antecedente -->
    <modal name="nuevoAntecedente" height="auto" :draggable="true">
      <form @submit.prevent="nuevoAntecedente()">
        <div class="modal-header" style="padding: 8px">
          <div class="row">
            <div class="col-md-1">
              <i v-if="e_antecedente == true" class="fa fa-backward"></i>
              <i
                v-if="e_antecedente == false"
                class="fa fa-spinner"
                style="font-size: 37px !important"
              ></i>
            </div>
            <div class="col-md-7">
              <p v-if="e_antecedente == true" class="titulo-modal">
                NUEVO ANTECEDENTE
              </p>
              <p v-if="e_antecedente == false" class="titulo-modal">
                ENVIANDO INFORMACIÓN
              </p>
              <p class="texto-pequeno">Registrar antecedentes del paciente</p>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <label for>Descripción del antecedente:</label>

          <textarea
            v-model="descripcionAntecedente"
            name
            id
            cols="30"
            rows="5"
            class="form-control"
            required
          ></textarea>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="cerrarModalNuevoAntecedente()"
          >
            <i class="fa fa-close"></i>Cancelar
          </button>
          <button
            v-if="e_antecedente == true"
            class="btn btn-success btn-fill"
            type="submit"
          >
             Guardar <i class="fa fa-plus"></i>
          </button>
          <button
            v-if="e_antecedente == false"
            class="btn btn-success "
            disabled
          >
            <i class="fa fa-spinner"></i> Guardarando...
          </button>
        </div>
      </form>
    </modal>
    <!-- fin nuevo antecedente -->
    <!-- Inicio modal agregar anamnesis -->

    <modal
      name="modalAnamnesis"
      width="700"
      height="auto"
      :draggable="true"
      :reset="true"
    >
      <form @submit.prevent="nuevoResumen()">
        <div class="modal-header" style="padding: 8px">
          <div class="row">
            <div class="col-md-1">
              <i v-if="e_resumen == true" class="fa fa-file"></i>
              <i
                v-if="e_resumen == false"
                style="font-size: 37px !important"
                class="fa fa-spinner"
              ></i>
            </div>
            <div class="col-md-7">
              <strong v-if="e_resumen == true" class="titulo-modal">
                NUEVA OBSERVACIÓN
              </strong>
              <strong v-if="e_resumen == false" class="titulo-modal">
                ENVIANDO INFORMACIÓN
              </strong>
              <!-- <p class="texto-pequeno">Registrar nueva anamnesis</p> -->
            </div>
          </div>
        </div>
        <div class="modal-body">
          <label>Observación general:</label>
          <textarea
            v-model="descripcionResumen"
            required
            class="form-control"
            id
            cols="30"
            rows="10"
          ></textarea>
          {{ descripcionResumen.length }}/ 30.000
          <br />
          <!-- <label for>Impresion diagnostica:</label> -->
          <br />

          <!-- <label for>Conclusiones:</label>
          <textarea v-model="conclusiones" cols="30" rows="3" class="form-control"></textarea>-->
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="cerrarModalResumen()"
          >
            <i class="fa fa-close"></i>Cancelar
          </button>
          <button
            type="submit"
            v-if="e_resumen == true"
            class="btn btn-success btn-fill"
          >
            Guardar <i class="fa fa-plus"></i>
          </button>
          <button
            type="button"
            v-if="e_resumen == false"
            disabled
            class="btn btn-success btn-sm"
          >
            <i class="fa fa-spinner"></i>Guardando...
          </button>
        </div>
      </form>
    </modal>
    <!-- Fin modal agregar anamnesis -->

    <!-- Inicio modal detalle anamnesis -->
    <!-- <modal
      name="modalDetalleAnamnesis"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      width="500"
      height="auto"
      :draggable="true"
    >
      <div class="modal-header CM" style="padding:8px">
        <strong class="modal-tittle">
          <i class="fa fa-file-text-o"></i> Detalles de la anamnesis
        </strong>
        <button
          type="button"
          @click="cerrarModalDetalleResumen()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-body">
          <input type="date" readonly class="form-control" v-model="detalleResumenFecha" />
          <br />

          <label>Impresión general:</label>
          <textarea
            v-model="detalleDescripcionResumen"
            disabled
            class="form-control"
            id
            cols="30"
            rows="2"
          ></textarea>
          <br />
          <label for>Impresion diagnostica:</label>
          <br />

          <label for>CIE10:</label>
          <el-select
            disabled
            multiple
            class="select-default"
            size="large"
            style="width: 100%; color:white"
            v-model="detalleCie10"
            placeholder="Seleccione..."
          >
            <el-option
              v-for="option in arrayCie10"
              class="select-primary"
              :value="option.DomDes"
              :label="option.DomDes"
              :key="option.DomIde"
            ></el-option>
          </el-select>
          <br />
          <br />

          <label for>DSM4:</label>
          <el-select
            disabled
            multiple
            class="select-default"
            size="large"
            style="width: 100%; color:white"
            v-model="detalleDsm4"
            placeholder="Seleccione..."
          >
            <el-option
              v-for="option in arrayDsm4"
              class="select-primary"
              :value="option.DomDes"
              :label="option.DomDes"
              :key="option.DomIde"
            ></el-option>
          </el-select>
          <br />
          <br />
          <label for>Conclusiones:</label>
          <textarea
            v-model="detalleConclusionResumen"
            disabled
            cols="30"
            rows="2"
            class="form-control"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-defalut btn-fill"
          @click="cerrarModalDetalleResumen()"
          data-dismiss="modal"
        >Cerrar</button>
      </div>
    </modal>-->

    <!-- modal editar dx -->
    <modal
      name="modaleditardx"
      :draggable="false"
      height="300"
      width="600"
      :reset="true"
    >
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-file"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">Editar DX</p>
            <p class="texto-pequeno">Editar Dx (CIE10) del paciente</p>
          </div>
        </div>
      </div>
      <div class="modal-body scroll-gg">
        <br />
        <div class="row">
          <div class="col-md-12">
            <form>
              <el-select
                multiple
                class="select-default"
                size="large"
                style="width: 100%; color: white"
                v-model="dxedit"
                placeholder="Seleccione..."
                filterable
                remote
              >
                <el-option
                  v-for="option in arrayCie10"
                  class="select-primary"
                  :value="option.DomDes"
                  :label="option.DomDes"
                  :key="option.DomIde"
                ></el-option>
              </el-select>

              <br />
              <br />
              <center>
                <button
                  @click="editDX()"
                  class="btn btn-success btn-sm"
                  v-if="estado == 1"
                >
                  Actualizar DX <i class="fa fa-pencil"></i>
                </button>
                <button
                  @click="cerrarPrepararEditDx()"
                  class="btn btn-danger btn-sm"
                >
                  Cancelar <i class="fa fa-close"></i>
                </button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </modal>
    <!-- fin modal editar dx -->

    <!-- Fin modal agregar detalle anamnesis -->
    <!-- Modal -->
    <modal
      name="modalNuevoPlan"
      :draggable="true"
      height="auto"
      width="800"
      :scrollable="true"
      :reset="true"
    >
      <form @submit.prevent="nuevoPlanTratamiento()">
        <div class="modal-header" style="padding: 8px">
          <div class="row">
            <div class="col-md-1">
              <i v-if="e_tratamiento == true" class="fa fa-file"></i>
              <i
                v-if="e_tratamiento == false"
                style="font-size: 50px !important"
                class="fa fa-spinner"
              ></i>
            </div>
            <div class="col-md-7">
              <strong v-if="e_tratamiento == true" class="titulo-modal">
                NUEVO PLAN DE TRATAMIENTO
              </strong>
              <strong v-if="e_tratamiento == false" class="titulo-modal">
                ENVIANDO INFORMACIÓN
              </strong>
              <!-- <p class="texto-pequeno">Plan de tratamiento del paciente</p> -->
            </div>
          </div>
        </div>
        <div class="modal-body scroll-gg">
          <div class="row">
            <div class="col-md-6">
              <label for="fechaTratamiento">Fecha inicial del tratamiento:</label>
              <input
                type="date"
                v-model="fechaTratamiento"
                required
                id="fechaTratamiento"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="fechaFinTratamiento">Fecha fin del tratamiento:</label>
              <input
                type="date"
                id="fechaFinTratamiento"
                v-if="indefinido == false"
                v-model="fechaFinTratamiento"
                class="form-control"
              />
              <input type="checkbox" v-model="indefinido" /> Indefinido
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label for="conclusiones_t">Conclusiones:</label>
              <textarea
                name
                v-model="descripcionTratamiento"
                class="form-control input-sm"
                id="conclusiones_t"
                cols="30"
                rows="6"
                required
              ></textarea>
            </div>
            <div class="col-md-12">
              <label for="conclusiones_t">Recomendaciones:</label>
              <textarea
                name
                v-model="recomendacionesTratamiento"
                class="form-control input-sm"
                id="conclusiones_t"
                cols="30"
                rows="6"
                required
              ></textarea>
            </div>
            <!-- <div class="col-md-6">
              <br />
              <label for>CIE10:</label>
              <input type="checkbox" v-model="mostrarCie10" />
              <el-select
                multiple
                class="select-default"
                size="large"
                style="width: 100%; color: white"
                v-model="cie10"
                placeholder="Seleccione..."
                v-if="mostrarCie10 == true"
                filterable
                remote
              >
                <el-option
                  v-for="option in arrayCie10"
                  class="select-primary"
                  :value="option.DomDes"
                  :label="option.DomDes"
                  :key="option.DomIde"
                ></el-option>
              </el-select>
              <br />
              <label for>DSM5:</label> <br />
              <input type="checkbox" v-model="mostrarDsm4" />
              <a
                target="_blank"
                href="https://dsm.psychiatryonline.org/pb-assets/dsm/update/Spanish_DSM5Update2016.pdf"
                >Link de consulta DSM5</a
              >
            </div> -->
          </div>

          <div class="row">
            
            <div class="col-md-6"></div>
          </div>

          <div class="row">
            <div class="col-md-12" style="margin-top:10px">
              <strong>Terapias y sesiones recomendadas:</strong>
              <br />
              <div class="row">
                <div class="col-md-12">
                  <br>
                  <Label>Seleccione el periodo de las sesiones:</Label>
                </div>
                <div class="col-md-2">
                  <label for="p1">Semanal</label>
                  <input type="radio" id="p1" v-model="periodoPT" value="1" />
                </div>
                <div class="col-md-2">
                  <label for="p2">Mensual</label>
                  <input type="radio" id="p2" v-model="periodoPT" value="2" />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <br>
                <div class="col-md-7">
                  <label for="especialidadtratamiento">Especialidad:</label>
                  <select
                    name
                    v-model="especialidad"
                    class="form-control"
                    id="especialidadtratamiento"
                  >
                    <option
                      v-for="especialidad in arrayEspecialidades"
                      :key="especialidad.EspCod"
                      :value="[especialidad.EspCod, especialidad.EspNom]"
                      v-text="especialidad.EspNom"
                    ></option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label for="sesionestratamiento">Sesiones:</label>
                  <input
                    type="number"
                    v-model="sesiones"
                    id="sesionestratamiento"
                    class="form-control"
                  />
                </div>
                <div class="col-md-1" style="padding-top: 25px">
                  <!-- <p style="color: white" for>----</p> -->
                  <button
                    @click="nuevaEspecialidad()"
                    type="button"
                    class="
                      btn btn-success btn-fill
                    "
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <br />
              <div class="table-responsive">
                <table
                  class="
                    el-table
                    table-striped
                    el-table--fit
                    el-table--enable-row-hover
                    el-table--enable-row-transition
                  "
                  id="example"
                >
                  <thead>
                    <tr>
                      <!-- <th>Index</th> -->
                      <th style="text-align: center">Cups</th>
                      <th style="text-align: center">Especialidad</th>
                      <th style="text-align: center">Sesiones</th>
                      <th style="text-align: center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(tratamiento, index) in arrayEspecialidad"
                      :key="tratamiento.EspNom"
                    >
                      <!-- <td v-text="index"></td> -->
                      <td
                        style="text-align: center"
                        v-text="tratamiento.especialidad"
                      ></td>
                      <td
                        style="text-align: center"
                        v-text="tratamiento.nombre"
                      ></td>
                      <td
                        style="text-align: center"
                        v-text="tratamiento.sesiones"
                      ></td>
                      <td style="text-align: center">
                        <a
                          class="
                            btn btn-simple btn-xs btn-danger btn-icon
                            remove
                          "
                          @click="eliminarServicio(index)"
                        >
                          <i class="ti-close"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="cerrarModalNuevoPlan()"
            data-dismiss="modal"
          >
            <i class="fa fa-close"></i> Cancelar
          </button>

          <button
            type="submit"
            v-if="e_tratamiento == true && arrayEspecialidad != ''"
            class="btn btn-success btn-fill"
          >
             Guardar <i class="fa fa-plus"></i>
          </button>
          <button
            type="button"
            disabled
            v-if="e_tratamiento == true && arrayEspecialidad == ''"
            class="btn btn-success btn-fill"
          >
            Guardar  <i class="fa fa-plus"></i>
          </button>
          <button
            type="button"
            v-if="e_tratamiento == false"
            disabled
            class="btn btn-success"
          >
            <i class="fa fa-spinner"></i> Guardando...
          </button>
        </div>
      </form>
    </modal>

    <modal name="pdfEva" height="auto" width="800">
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-file"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">Exportar informe de evaluación</p>
            <p class="texto-pequeno">Generar informe de evaluación</p>
          </div>
        </div>
      </div>
      <div class="modal-body scroll">
        <div class="row">
          <div class="col-md-12">
            <label for="">Motivo de consulta verificado:</label>
            <textarea v-model="motivoPDF" class="form-control" cols="30" rows="5"> </textarea>
          </div>
          <div class="col-md-12">
            <label for="">Antecedentes prenatales:</label>
            <input v-model="antecedentesPrePDF" class="form-control" />
          </div>
          <div class="col-md-12">
            <label for="">Antecedentes posnatales:</label>
            <input v-model="antecedentesPosPDF" class="form-control" />
          </div>
          <div class="col-md-12">
            <label for="">Antecedentes perinatales:</label>
            <input v-model="antecedentesNeoPDF" class="form-control" />
          </div>
          <div class="col-md-12">
            <label for="">Antecedentes personales:</label>
            <input v-model="antecedentesPerPDF" class="form-control" />
          </div>
          <div class="col-md-12">
            <label for="">Antecedentes familiares:</label>
            <input v-model="antecedentesFamPDF" class="form-control" />
          </div>
          <div class="col-md-12">
            <label for="">Impresión general:</label>
            <textarea
              class="form-control"
              v-model="impresionesPDF"
              cols="30"
              rows="5"
            >
            </textarea>
          </div>
          <div class="col-md-12">
            <label for="">Conclusiones:</label>
            <textarea
              class="form-control"
              v-model="descripcionTratamiento"
              cols="30"
              rows="5"
            >
            </textarea>
          </div>
          <div class="col-md-12">
            <label for="">Recomendación:</label>
            <textarea
              v-model="recomendacionesTratamiento"
              cols="30"
              rows="5"
              class="form-control"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          style="margin: 1%; border-radius: 5px"
          type="button"
          class="btn btn-danger btn-fill"
          @click="cerrarModalpdf()"
        >
          <i class="fa fa-close"></i> Cerrar
        </button>
        <button
          style="margin: 1%; border-radius: 5px"
          type="button"
          class="btn btn-success btn-fill"
          @click="generarInforme()"
        >
          <i class="fa fa-file" style="font-size: 12px !important"></i> Generar
          Informe
        </button>
        <br />
      </div>
    </modal>

    <modal
      name="modalNuevoPlanDetalle"
      height="auto"
      width="800"
      :scrollable="true"
      :reset="true"
    >
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-file"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">VER DETALLES DEL TRATAMIENTO</p>
            <p class="texto-pequeno">
              Plan de tratamiento del paciente detallado
            </p>
          </div>
          <!-- <div class="col-md-4">
            <button
              v-if="
                terapeutaPDF == usuarioAvanza || rol == 1 || rol == 15
              "
              class="btn btn-success btn-block"
              @click="prepararPDFEva()"
              style="border-radius:10px;"
            >
              Exportar evaluación
              <i class="fa fa-file" style="font-size: 15px !important"></i>
            </button>
          </div> -->
        </div>
      </div>
      <div class="modal-body scroll">
        <div class="row">
          <div class="col-md-6">
            <label for>Fecha inicial del tratamiento:</label>
            <input
              type="date"
              readonly
              v-model="fechaTratamiento"
              class="form-control"
            />
          </div>
          <div class="col-md-6">
            <label for>Fecha fin del tratamiento:</label>

            <input
              v-if="fechaFinTratamiento!=null"
              type="date"
              readonly
              v-model="fechaFinTratamiento"
              class="form-control"
            />
            
            <input type="text" class="form-control" readonly v-else value="Tratamiento indefinido">
            
          </div>
          <br />
        </div>

        <hr class="py-4">

        <div class="row">
         
          <div class="col-md-6">
            <label for="">DX:</label>
            <textarea class="form-control" rows="8" readonly :value="cie10mostrar"> </textarea>
          </div>
          <div class="col-md-6">
            <br />
            <strong style="color: grey; font-size: 20px"
              >Terapias y sesiones:</strong
            >
            <div class="table-responsive">
              <br />
              <table
                class="
                  el-table
                  table-striped
                  el-table--fit
                  el-table--enable-row-hover
                  el-table--enable-row-transition
                  table-bordered
                "
                
              >
                <thead>
                  <tr>
                    <th style="text-align: center">Especialidad</th>
                    <th style="text-align: center">Sesiones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="tratamiento in arrayDetalle"
                    :key="tratamiento.EspNom"
                  >
                    <td
                      style="text-align: center"
                      v-text="tratamiento.EspNom"
                    ></td>
                    <td
                      style="text-align: center"
                      v-text="tratamiento.TraEspSes"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-md-12">
            <br />
            <label for>Conclusiones:</label>
            <textarea
              readonly
              v-model="descripcionTratamiento"
              class="form-control" 
              cols="30"
              rows="4"
            ></textarea>
          </div>
          <div class="col-md-12">
            <br />
            <label for>recomendaciones:</label>
            <textarea
              readonly
              v-model="recomendacionesTratamiento"
              class="form-control" 
              cols="30"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          style="border-radius:10px;"
          type="button"
          class="btn btn-secondary btn-fill"
          @click="cerrarModalDetallePlan()"
        >
          <i class="fa fa-close"></i> Cerrar
        </button>
        <br />
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Collapse, CollapseItem } from "element-ui";
import crearAlerta from "../../global-services/crearAlerta";
import VueTabs from "vue-nav-tabs";
import VModal from "vue-js-modal";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

Vue.use(VModal);
Vue.use(VueTabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Table);
Vue.use(Select);
Vue.use(TableColumn);
export default {
  data() {
    return {
      dxeditId: "",
      dxedit: [],
      usuarioAvanza: "",
      motivosConsulta: "",
      optionsArray: [],
      tmconsulta: [],
      informacion: "",
      pacientes: [],
      arrayMotivo: [], //NOMBRE DEL ARRAY EN EL QUE VAS A ALMACENAR LOS DATOS
      //POR EJEMPLO pacientes: [] solo aquí es donde lo declaras
      criterio: "paciente.PacApe1",
      busqueda: "",
      anos: 0,
      meses: 0,
      multiple: "ARS",

      // datos paciente
      numeroDocumento: "",
      tipoDocumentoPDF: '',
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      Fecha_nacimiento: "",
      diagnosticoPaciente: "",
      sexo: "",
      labelSexo: {
        1: "Masculino",
        2: "Femenino",
        3: "Gay",
        4: "Lesbiana",
        5: "Bisexual",
        6: "Transgénero",
        7: "Intersexual",
        8: "Sin definir"
      },
      eps: "",
      poliza: "",
      prepagada: "",
      tipoAfiliacion: "",
      regimen: 1,
      PacIde: "",
      loked: true,
      numeroDocumentoBuscar: "",
      fotoPaciente: "",
      estado: 0,
      rol: localStorage.getItem("rol"),

      // consulta
      motivoDeConsulta: "",
      fechaDeConsulta: "",
      fechaVerificado: "",
      motivoVerificarIde: "",
      motivoVerificarFec: "",
      motivoVerificarDes: "",
      consultaVerificada: "",
      contador_motivos: 0,
      evoluciones: [],
      fechaInicialEvoluciones: '',
      fechaFinalEvoluciones: '',
      // array Motivo

      // array impresion
      arrayImpresion: [],

      // antecedente
      tipoAntecedente: 1,
      antecedenteActivo: "",
      fechaAntecedente: "",

      descripcionAntecedente: "",
      antecedentesPre: [],
      contador_pre: 0,
      antecedentesNeo: [],
      antecedentesPos: [],
      antecedentesPer: [],
      antecedentesFam: [],
      fotoBASE: "",

      // impresion
      // fechaImpresion : '',

      // resumen

      fechaResumen: "",
      descripcionResumen: "",
      arrayResumen: [],
      descripcionImpresion: "",
      impresionDiagnostica: "",
      conclusiones: "",
      arrayAntecedente: [],
      arrayCie10: [],
      arrayDsm4: [],
      cie10: [],
      dsm4: [],
      conclusiones: "",
      detalleResumenFecha: "",
      detalleDescripcionResumen: "",
      detalleConclusionResumen: "",
      detalleCie10: [],
      detalleDsm4: [],

      // plan tratamiento

      fechaTratamiento: "",
      descripcionTratamiento: "",
      recomendacionesTratamiento: "",
      arrayTratamiento: "",
      arrayEspecialidad: [],
      arrayEspecialidades: [],
      especialidad: "",
      sesiones: "",
      arrayDetalle: [],
      fechaFinTratamiento: "",
      actividadFamiliar: "",
      trabajoFamiliar: "",
      fechaIngresoTratamiento: '',

      // examen

      examen: 0,
      verificacion: false,
      mostrarCie10: true,
      mostrarDsm4: true,
      opcion: 1,

      //Examenes
      arrayExamen: [],
      
      examenes_t: [],
      examenesPDF: [],
      examenActivo: 1,
      arrayActivo: [],
      examenEnviar: "",
      nombreExamen: "",
      links_examen: [
        "NULL",
        "https://drive.google.com/file/d/1QQvTRCVPfbgasJ-agXYymsFzCSOsIEtp/view?usp=sharing",
        "https://drive.google.com/file/d/1nZTTxOPpTy_RYbcqFcClm6wEKMqsM2yx/view?usp=sharing",
        "https://drive.google.com/file/d/1AKYS5wSOs8cCh0fVc4cE3Tc32GcAvhrG/view",
        "https://drive.google.com/file/d/1um4R2ymKd_gdww2WPBsdwzmS1dHoQf5R/view",
        "https://drive.google.com/file/d/1y9pVcX8QR55yyxtzmjsELkNB-FpQMeXA/view?usp=sharing",
        "https://drive.google.com/open?id=1uHrljOme7yU-7Ssok1mr1A3ajGsUC_lD",
        "https://drive.google.com/open?id=1d5K0en09ws3umkRoXZF5UC548tTmhDnB",
        "https://drive.google.com/file/d/17EaZD7K4bddoVmuTIm9kpqMhsZ4kVKww/view",
        "https://drive.google.com/open?id=1-WrHRmIMCbXO-dq3MuwuaUHbTRf8knM0",
        "https://drive.google.com/open?id=1tzemT8CBzdUW5E9I8449NjlGP-2hma03",
        "https://drive.google.com/file/d/0B54PTJg2YNL-TVFvbnpTc3laZGc/view?resourcekey=0-QCwexOdYyxlTsC5V9hT7Cw",
        '#',
        'https://docs.google.com/document/d/1k1QfqebMl0yT2aVeryIY9VQquUISuvy7/edit',
        'https://docs.google.com/document/d/18Af8DG-pIWLo-mdTMGaF8Wo20B79L0QB/edit?usp=sharing&ouid=106019725576061634179&rtpof=true&sd=true',
        'https://docs.google.com/document/d/1a8hvVTjdBAXPb7VBq-PIX36M_xMER3cb/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true',
        'https://drive.google.com/file/d/1FPTdBztShATSSt_94O5BKVOI-7bKJB_U/view?usp=drive_link',
        'https://drive.google.com/file/d/1YGdKPoXQhxY36SImDmLWcGJKWQEneHlO/view?usp=drive_link',
        'https://drive.google.com/file/d/1aCNi2Kni2P-3uSxicDIyFxsNJrh0KwD3/view?usp=drive_link',
        'https://drive.google.com/file/d/1jaLNu7r7pMHFmLpZYOGTujePWYYNyuuh/view?usp=drive_link',
        'https://docs.google.com/document/d/1gdz2aMJsENNy3oD30O76lDJZfsDRja0_/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true',
        'https://docs.google.com/document/d/1Zm6lASLGaJG3DH-oYQSKN_ZUcGeSqcrT/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true'
      ],
      link_examen_selecte: "",
      // tratamiento
      tratamiento: [],
      // pdf

      motivoPDF: [],
      motivoPDF_id: 0,
      impresionesPDF: [],
      antecedentesPrePDF: [],
      antecedentesNeoPDF: [],
      antecedentesNeo: [],
      antecedentesPosPDF: [],
      antecedentesPos: [],
      antecedentesPerPDF: [],
      antecedentesPer: [],
      antecedentesFamPDF: [],
      antecedentesFam: [],
      conclusionesPDF: [],
      terapeutaPDF: '',

      // notificaciones
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      ip: "https://avanti-erp.com/",
      mensaje: "No hay datos de pacientes",
      icono: "bell",
      examenesRealizados: [],
      examenesRealizadosPs: [],
      examenesRealizadosfonol: [],
      indefinido: false,
      periodoPT: 1,
      motivoConsultaHoy: false,
      motivoConsultaUsuario: false,
      antecedenteHoy: false,
      impresionHoy: false,
      examenHoy: false,
      tratamientoHoy: false,
      e_motivo: true,
      e_antecedente: true,
      e_resumen: true,
      e_tratamiento: true,
      cie10mostrar: "",
      logo: "",
      terapeutaPDF: "",
      recomendacionPDF: "",
      fechaPDF: '',
      examenesPaciente: [],

      inputFirma: ''
    };
  },
  methods: {
    prepararEditDX(dx) {
      this.$modal.show("modaleditardx");
      if (dx != null) {
        dx = dx.split(", ");
        this.dxedit = dx;
      }
    },

    abrirModalVerificarFirma: function(){
      const ROL = localStorage.getItem('rol');
      if(ROL > 1 && ROL < 7){
        this.$modal.show('modalVerificarFirmaElectronica');
      }
    },

    verificarFirmaElectronica: function(){
      this.$modal.show('carga');
      const FIRMA = localStorage.getItem('firmaElectronica');
      if(this.inputFirma === FIRMA){
        this.$notify(crearAlerta("success", 'Firma valida'));
        this.$modal.hide('modalVerificarFirmaElectronica');
        this.$modal.hide('carga');
      }else{
        this.$notify(crearAlerta("danger", "Firma invalida"));
        this.$modal.hide('carga');
      }
    },

    cerrarPrepararEditDx() {
      this.$modal.hide("modaleditardx");
    },

    editDX: function () {
      if (false) {
        alert("No se permite DX vacio");
      } else {
        let config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };

        let textoDelArray = "";
        for (let i = 0; i < this.dxedit.length; i++) {
          textoDelArray = textoDelArray + ` ${this.dxedit[i]},`;
        }

        const BASE_URL = `${this.ip}api/editDXV2`;
        axios
          .post(
            BASE_URL,
            {
              id: this.PacIde,
              dx: textoDelArray.toUpperCase(),
            },
            config
          )
          .then((res) => {
            if (res.data.status == true) {
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: ` <div style="padding: 3%;">
              <span><b> ACTUALIZADO CON ÉXITO </b>.</span>
              </div>
              `,
                },
                icon: "ti-check",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: this.type[color],
              });
              this.diagnosticoPaciente = textoDelArray;
              this.cerrarPrepararEditDx();
            }
          }).catch((error) => {
            console.log(error);
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ERROR AL ACTUALIZAR DX </b>.</span>
              </div>
              `,
              },
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
          });
      }
    },
    prepararPDFEva() {
      this.$modal.show("pdfEva");
      this.$modal.hide("modalNuevoPlanDetalle");
      this.selectDataInformeEvolucion(
        this.fechaIngresoTratamiento,
        this.terapeutaPDF,
        this.descripcionTratamiento
      );
    },

    cerrarModalpdf() {
      this.$modal.hide("pdfEva");
      this.recomendacionPDF = "";
    },
    generarInforme() {
     if(this.recomendacionesTratamiento != ''){
        let informacion = [
        {
          terapeuta: this.terapeutaPDF,
          fecha: this.fechaPDF,
          recomendaciones: this.recomendacionesTratamiento,
          antecedentes_prenatales: this.antecedentesPrePDF,
          antecedentes_neonatales: this.antecedentesNeoPDF,
          antecedentes_postnatales: this.antecedentesPosPDF,
          antecedentes_personales: this.antecedentesPerPDF,
          antecedentes_familiares: this.antecedentesFamPDF,
          conclusiones: this.descripcionTratamiento,
          examenes: this.examenesPDF,
          motivo: this.motivoPDF,
          motivoId: this.motivoPDF_id,
          impresion: this.impresionesPDF
        },
      ];

      let paciente = [
        {
          edad: `${this.anos} año(s) y ${this.meses} mes(es)`,
          nombre: `${this.nombres} ${this.apellidos}`,
          tipoDocumento: this.tipoDocumentoPDF,
          documento: this.numeroDocumento,
          ide: this.PacIde
        }
      ]
      axios({
        method: "post",
        url: "https://avanti-erp.com/api/imprimir",
        responseType: "arraybuffer",
        data: {
          formularioData : informacion,
          paciente: paciente
        },
      }).then(function (response) {
        if(response.headers['content-type'] == 'application/pdf'){
          let blob = new Blob([response.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `informe_evaluacion_${paciente[0].nombre}.pdf`;
          link.click();

        }else{  
          alert('El usuario que registró el plan no es terapeuta')
        }

        // console.log(response.headers['content-type']);

      });
      this.cerrarModalpdf();
     }else{
       alert('El campo de recomendaciones es requerido para generar el informe');
     }
    },
    realizarExamen() {
      //  let routeData = this.$router.resolve({name: 'Evaluacion Psicológica Niños', query: {data: "someData"}}); window.open(routeData.href, '_blank');
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();
    },

    abrirModalAgregar() {
      this.$modal.show("modalAgregar");
      this.tmconsulta = [];
      this.motivosConsulta = "";
      this.consultaVerificada = "";
    },

    cerrarModalMotivo() {
      this.$modal.hide("modalAgregar");
    },

    cerrarModalMotivoVerificar() {
      this.$modal.hide("modalVerificarMC");
    },
    abrirModalAntecedente(tipo) {
      this.$modal.show("nuevoAntecedente");
      this.descripcionAntecedente = "";
      this.tipoAntecedente = tipo;
    },
    cerrarModalNuevoAntecedente() {
      this.$modal.hide("nuevoAntecedente");
    },

    abriModalAnamnesis() {
      this.$modal.show("modalAnamnesis");
    },
    cerrarModalResumen() {
      this.$modal.hide("modalAnamnesis");
    },
    cerrarModalDetalleResumen() {
      this.$modal.hide("modalDetalleAnamnesis");
    },
    abriModalNuevoPlan() {
      this.$modal.show("modalNuevoPlan");
      (this.fechaTratamiento = ""),
        (this.descripcionTratamiento = ""),
        (this.especialidad = ""),
        (this.sesiones = ""),
        (this.fechaFinTratamiento = ""),
        (this.actividadFamiliar = ""),
        (this.trabajoFamiliar = ""),
        (this.arrayEspecialidad = []);
      this.selectEspecialidad();
    },
    cerrarModalDetallePlan() {
      this.$modal.hide("modalNuevoPlanDetalle");
    },
    cerrarModalNuevoPlan() {
      this.$modal.hide("modalNuevoPlan");
    },
    cerrarHC() {
      this.opcion = 1;
      this.arrayMotivo = [];
      this.arrayExamen = [];
      this.examenesPaciente = [];
      this.arrayActivo = [];
      localStorage.removeItem("PacienteHC");
      localStorage.removeItem("PacienteId");
    },
    cambiarLinkExamen: function () {
      this.link_examen_selecte = this.links_examen[this.examen];
    },
    motivos() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/motivos/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.arrayMotivo = response.data.data;
          console.log(this.arrayMotivo, 'motivos');
          this.contador_motivos = this.arrayMotivo.length;
          if (response.data.data.length > 0) {
            this.motivoConsultaHoy = true;
          }
          this.validarMotivosIngresadosHoy(response.data.data);
          this.validarMotivosVerificados(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validarMotivosVerificados(motivos) {
      for (let index = 0; index < motivos.length; index++) {
        if (motivos[index].MotEst != 1) {
          this.motivoConsultaHoy = false;
        }
        // console.log(motivos[index]);
      }
    },
    validarMotivosIngresadosHoy(motivos) {
      for (let index = 0; index < motivos.length; index++) {
        if (motivos[index].MotFec == this.fechaDeConsulta &&  motivos[index].MotTer == this.usuarioAvanza
        || motivos[index].updated_at.substring(0, 10) == this.fechaDeConsulta &&  motivos[index].MotTer == this.usuarioAvanza) {
          // this.motivoConsultaHoy = false;
          this.motivoConsultaUsuario = true;
        }
        // console.log(motivos[index]);
      }
    },
    motivosM() {
      this.optionsArray = [];
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/motivos",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.optionsArray = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    motivoVerificar(row, option = 1) {
      this.verificacion = row.MotEst;
      if (this.verificacion == 0 && option == 1) {
        this.$modal.show("modalVerificarMC");
      }
      if (this.verificacion != 0 && option == 1) {
        this.$modal.show("modalDetallesMC");
      }
      this.tmconsulta = [];
      this.motivoVerificarIde = row.MotIde;
      this.motivoVerificarFec = row.MotFec;
      this.motivoVerificarDes = row.MotDes;
      this.consultaVerificada = row.MotVer;
      var token = localStorage.getItem("token");
      // let dateDB = [];
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/completo/" + this.motivoVerificarIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let datos = response.data.data.length;
          for (let i = 0; i < datos; ) {
            this.tmconsulta.push(response.data.data[i].VerDes);
            i++;
          }

          if (option == 1) {
            this.motivos();
          }
        })

        .catch(function (error) {
          console.log(error);
        });

      // console.log(motivo);
    },
    nuevoMotivoConsulta() {
      var token = localStorage.getItem("token");
      if (this.motivoConsulta != "") {
        axios
          .request({
            method: "post",
            baseURL: this.ip + "api/nuevoMotivo",
            data: {
              MotFec: this.fechaDeConsulta,
              PacIde: this.PacIde,
              MotDes: this.motivosConsulta,
            },
            headers: {
              Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data == 1) {
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: `<span>-<b> Motivo registrado con éxito!</b>.</span>`,
                },
                icon: "ti-check",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: this.type["success"],
              });
            }
            // vm.fechaDeConsulta = "";
            this.motivoDeConsulta = "";
            this.fechaDeConsulta = "";
            this.motivosConsulta = "";
            this.motivos();
            this.estadoModalAgregarMC = 0;

            this.$modal.hide("modalAgregar");
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    nuevoMotivoConsultaVerificado() {
      this.e_motivo = false;
      var token = localStorage.getItem("token");
      if (this.PacIde != "") {
        if (this.motivoConsulta != "") {
          axios
            .request({
              method: "post",
              baseURL: this.ip + "api/nuevoMotivoVerificado",
              data: {
                MotFec: this.fechaDeConsulta,
                PacIde: this.PacIde,
                MotDes: this.motivosConsulta,
                Parametros: this.tmconsulta,
                verificada: this.consultaVerificada,
                MotTer: localStorage.getItem("usuario"),
              },
              headers: {
                Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: `<span>-<b> Motivo registrado con éxito!</b>.</span>`,
                },
                icon: "ti-check",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: this.type["success"],
              });

              this.motivosConsulta = "";
              this.consultaVerificada = "";
              this.tmconsulta = [];
              this.estadoModalAgregarMC = 0;
              this.motivos();
              this.motivoConsultaHoy = true;
              this.$modal.hide("modalAgregar");
              this.e_motivo = "enviar";
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        alert("Faltan Datos Del Paciente");
      }
    },

    verificarMotivo() {
      var token = localStorage.getItem("token");

      axios
        .request({
          method: "post",
          baseURL: this.ip + "api/verificar",
          data: {
            id: this.motivoVerificarIde,
            terminos: this.tmconsulta,
            consultaVerificada: this.consultaVerificada,
            fechaVerificado: this.fechaVerificado,
            terapeuta: localStorage.getItem("usuario"),
          },
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Motivo verificado!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type["success"],
          });
          this.motivos();
          this.estadoModalVerificarMC = 0;
          this.cerrarModalMotivoVerificar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    llamarPacientes(row) {
      let respuesta = "";
      this.numeroDocumentoBuscar = row.PacNumDoc;
      if (this.numeroDocumentoBuscar != "") {
        var buscar = this.numeroDocumentoBuscar;
        var token = localStorage.getItem("token");
        axios
          .request({
            method: "get",
            baseURL: this.ip + "api/pacienteHC/" + row.PacIdeUsu,
            headers: {
              Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.data == 0) {
              alert("No se encontraron datos");
            } else {
              this.PacIde = row.PacIdeUsu;
              this.numeroDocumento = response.data.data.datos[0].PacNumDoc;
              localStorage.setItem(
                "PacienteHC",
                response.data.data.datos[0].PacNumDoc
              );
              localStorage.setItem("PacienteId", row.PacIdeUsu);
              localStorage.setItem(
                "PacienteNombre",
                response.data.data.datos[0].PacNom1 +
                  " " +
                  response.data.data.datos[0].PacApe1
              );
              this.nombres = response.data.data.datos[0].PacNom1;
              this.apellidos = response.data.data.datos[0].PacApe1;
              this.fotoPaciente = response.data.data.datos[0].url_foto;
              this.sexo = this.labelSexo[response.data.data.datos[0].PacSex];
              this.tipoDocumentoPDF = response.data.data.datos[0].TipDocNom;
              // console.log('tipoDocumento', response.data.data.datos[0].TipDocNom)
              this.Fecha_nacimiento = response.data.data.datos[0].PacFecNac;
              this.fechaIngreso = response.data.data.datos[0].PacFecIng;
              this.eps = response.data.data.eps;
              this.prepagada = response.data.data.prepagada;
              this.tipoAfiliacion = response.data.data.datos[0].TipCliNom;
              this.poliza = response.data.data.poliza;
              this.diagnosticoPaciente = response.data.data.datos[0].PacDia;
              this.regimen = response.data.data.datos[0].PacReg == 1 ? "Contributivo" : "Subsidiado";


              this.estado = response.data.data.datos[0].estado;
              this.loked = response.data.data.datos[0].PacBlo;

              this.fotoBASE = response.data.data.datos[0].url_fotoBS;

              this.motivos();
              this.resumen();
              this.examenes();
              this.antecedentes();
              this.tratamientos();
              // this.e_realizados_to();
              // this.e_realizados_ps();
              // this.e_realizados_fonol();
              this.calcularEdad();
              // this.getEvoluciones(row.PacIdeUsu);
              this.motivoConsultaHoy = false;
              this.antecedenteHoy = false;
              this.impresionHoy = false;
              this.examenHoy = false;
              this.tratamientoHoy = false;
              this.e_motivo = true;
              this.opcion = 2;
              this.e_antecedente = true;
              this.e_resumen = true;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    buscarPacientes() {
      this.mensaje = "Cargando...";
      this.icono = "spinner";
      this.pacientes = [];
      var token = localStorage.getItem("token");

      let rol = localStorage.getItem('rol');
      let sedeBuscar = 'todas';
      if( rol > 1 ){
        sedeBuscar = localStorage.getItem('sede');
      }
      axios
        .request({
          method: "get",
          baseURL:
            this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda + "/" + sedeBuscar,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.icono = "bell";
          this.mensaje = "No hay datos de pacientes";
          this.pacientes = response.data.data;
          if (localStorage.getItem("PacienteHC")) {
            this.llamarPacientes(response.data.data[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cie10M() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/cie10",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.arrayCie10 = [];
          var datos = response.data.data.length;
          if (response.data.data != "") {
            for (let i = 0; i < datos; ) {
              this.arrayCie10.push(response.data.data[i]);
              // console.log(this.arrayCie10);
              i++;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    dsm4M() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/dsm4",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var datos = response.data.data.length;
          if (response.data.data != "") {
            for (let i = 0; i < datos; ) {
              this.arrayDsm4.push(response.data.data[i]);
              i++;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    nuevoAntecedente() {
      this.e_antecedente = false;
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "post",
          baseURL: this.ip + "api/nuevoAntecedente",
          data: {
            descripcion: this.descripcionAntecedente,
            PacIde: this.PacIde,
            terapeuta: localStorage.getItem("usuario"),
            tipo: this.tipoAntecedente,
          },
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.$modal.hide("nuevoAntecedente");
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Antecedente registrado con éxito!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type["success"],
          });
          this.antecedenteHoy = true;
          this.antecedentes();
          this.e_antecedente = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getEvoluciones: function (paciente) {
      this.$modal.show("carga");
      let lokedInformation = 0;
      if(this.loked != null && this.loked != '' && this.usuarioAvanza != this.loked ){
        lokedInformation = 1;
      }
      const BASE_URL = `${this.ip}api/obtener-evoluciones/${paciente}/${this.fechaInicialEvoluciones}/${this.fechaFinalEvoluciones}/${lokedInformation}`;
      let config = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .request({
          method: "get",
          baseURL: BASE_URL,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"), //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$modal.hide("carga");
          let evoluciones = [];
          // console.log('evoluciones', res.data);
          // this.evoluciones = res.data.data;
          for (let i = 0; i < res.data.data.length; i++) {
            evoluciones.push({
              EvoTer:
                res.data.data[i].nombres + " " + res.data.data[i].apellidos,
              Obs: res.data.data[i].Obs,
              EvoMat: res.data.data[i].EvoMat,
              EvoFec: res.data.data[i].EvoFec,
              EvoEst: res.data.data[i].EvoEst,
            });
          }
          this.evoluciones = evoluciones;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },

    antecedentes() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/antecedentes/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.antecedentesPre = response.data.data.pre;
          if (response.data.data.pre.length > 0) {
            this.antecedenteHoy = true;
          }
          this.contador_pre = response.data.data.pre.length;
          this.antecedentesNeo = response.data.data.neo;
          if (response.data.data.neo.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesPos = response.data.data.pos;
          if (response.data.data.pos.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesPer = response.data.data.per;
          if (response.data.data.per.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesFam = response.data.data.fam;
          if (response.data.data.fam.length > 0) {
            this.antecedenteHoy = true;
          }
          this.cambiarTipoAntecedente();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cambiarTipoAntecedente() {
      if (this.tipoAntecedente == "1") {
        this.antecedenteActivo = "Prenatales";
        this.arrayAntecedente = this.antecedentesPre;
      }
      if (this.tipoAntecedente == 2) {
        this.antecedenteActivo = "Neonatales";
        this.arrayAntecedente = this.antecedentesNeo;
      }
      if (this.tipoAntecedente == 3) {
        this.antecedenteActivo = "Postnatales";
        this.arrayAntecedente = this.antecedentesPos;
      }
      if (this.tipoAntecedente == 4) {
        this.antecedenteActivo = "Personales";
        this.arrayAntecedente = this.antecedentesPer;
      }
      if (this.tipoAntecedente == 5) {
        this.antecedenteActivo = "Familiares";
        this.arrayAntecedente = this.antecedentesFam;
      }
    },

    nuevoResumen() {
      this.e_resumen = false;
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "post",
          baseURL: this.ip + "api/nuevoResumen",
          data: {
            ResFec: this.fechaResumen,
            ResDes: this.descripcionResumen,
            PacIde: this.PacIde,
            ResCon: " ",
            terapeuta: localStorage.getItem("usuario"),
          },
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span><b> Amanmesis Registrada Con Éxito</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type["success"],
          });

          this.$modal.hide("modalAnamnesis");
          this.resumen();
          this.descripcionResumen = "";
          this.conclusiones = "";
          this.impresionHoy = true;
          this.e_resumen = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resumen() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/resumen/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.cie10M();
          this.dsm4M();
          this.arrayResumen = response.data.data;
          if (response.data.data.length > 0) {
            this.impresionHoy = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    detalleResumen(row) {
      var token = localStorage.getItem("token");
      this.detalleResumenFecha = row.ResFec;
      this.detalleDescripcionResumen = row.ResDes;
      this.detalleConclusionResumen = row.ResCon;
      this.$modal.show("modalDetalleAnamnesis");
      this.detalleDsm4 = [];
      this.detalleCie10 = [];

      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/detalleResumen/" + row.ResIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          for (let i = 0; i < response.data.data.cie10.length; i++) {
            this.detalleCie10.push(response.data.data.cie10[i].DetDes);
          }
          for (let i = 0; i < response.data.data.dsm4.length; i++) {
            this.detalleDsm4.push(response.data.data.dsm4[i].DetDes);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    examenes() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/examenes/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {

          this.examenesPaciente = response.data.data.examenes;
          

          this.examenes_t = response.data.data.examenes;

          for (let index = 1; index < 11; index++) {
            if (response.data.data["examenes" + index].length > 0) {
              this.examenHoy = true;
            }
          }
          this.tipoExamen();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tratamientos() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/tratamientos/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.tratamiento = response.data.data;
          if (response.data.data.length > 0) {
            this.tratamientoHoy = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    nuevoPlanTratamiento() {
      let textoDelArray = "";
      for (let i = 0; i < this.cie10.length; i++) {
        textoDelArray = textoDelArray + ` ${this.cie10[i]},`;
      }

      var token = localStorage.getItem("token");
      axios
        .request({
          method: "post",
          baseURL: this.ip + "api/nuevoTratamiento",
          data: {
            PacIde: this.PacIde,
            TraFec: this.fechaTratamiento,
            TraDes: this.descripcionTratamiento,
            TraRec: this.recomendacionesTratamiento,
            servicios: this.arrayEspecialidad,
            TraFecFin: this.fechaFinTratamiento,
            // TraActFam: this.actividadFamiliar,
            TraCas: textoDelArray,
            terapeuta: localStorage.getItem("usuario"),
          },
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span><b> Plan De Tratamiento Registrado Con Éxito</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type["success"],
          });
          this.calcularFechaActual();
          this.descripcionTratamiento = "";
          this.recomendacionesTratamiento = "";
          this.arrayEspecialidad = [];
          this.tratamientos();
          this.tratamientoHoy = true;
          this.$modal.hide("modalNuevoPlan");
          this.e_tratamiento = true;
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.e_tratamiento = true;
        });
    },

    nuevaEspecialidad() {
      if (this.especialidad != "" && this.sesiones != "") {
        this.arrayEspecialidad.push({
          especialidad: this.especialidad[0],
          sesiones: this.sesiones,
          nombre: this.especialidad[1],
        });
        this.especialidad = "";
        this.sesiones = "";
      }
      // console.log(this.arrayEspecialidad);
    },

    selectEspecialidad() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/selectEspecialidad",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.arrayEspecialidades = response.data.data;
          // console.log(this.arrayEspecialidades);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    verDetalle(row) {
      this.terapeutaPDF = "";
      this.$modal.show("modalNuevoPlanDetalle");
      var token = localStorage.getItem("token");
      var TraIde = row.TraIde;
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/detalle/" + TraIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.arrayDetalle = response.data.data;
          this.fechaTratamiento = row.TraFec;
          this.cie10mostrar = row.TraCas;
          (this.descripcionTratamiento = row.TraDes),
          this.recomendacionesTratamiento = row.TraActFam,
            (this.fechaFinTratamiento = row.TraFecFin),
            (this.actividadFamiliar = row.TraActFam);
          this.logo = response.data.logo;

          this.terapeutaPDF = row.terapeuta;
          this.fechaIngresoTratamiento = row.created_at.substring(0,10);
        })
        .catch(function (error) {});
    },
    tipoExamen() {
      this.cambiarLinkExamen();
      this.arrayActivo = this.examenesPaciente.filter(examen => examen.tipo == this.examen);
    },
    agregarExamen() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/nuevoExamen";
      axios
        .post(
          url,
          {
            examen: this.examenEnviar,
            nombreExamen: this.nombreExamen,
            PacIde: this.PacIde,
            IdPaciente: this.numeroDocumento,
            fecha: this.motivoVerificarFec,
            tipo: this.examen,
            terapeuta: localStorage.getItem("usuario"),
          },
          config
        )
        .then((response) => {
          this.examenes();
          this.nombreExamen = "";
          this.examenEnviar = null;
          this.examenHoy = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cargarExamen(e) {
      let reader = new FileReader();
      const examen1 = e.target.files[0];
      this.nombreExamen = e.target.files[0].name;
      this.examen2 = URL.createObjectURL(examen1);
      reader.readAsDataURL(examen1);
      reader.onload = (e) => {
        this.examenEnviar = e.target.result;
      };
      // console.log(this.examenEnviar);
    },

    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        // this.fechaIngreso = fechaActual;

        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        // calculamos los meses
        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
      // this.calcularFechaActual();
    },
    e_realizados_to: function () {
      let url = this.ip + "api/To_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizados = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    e_realizados_ps: function () {
      let url = this.ip + "api/ps_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizadosPs = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    e_realizados_fonol: function () {
      let url = this.ip + "api/fonoL_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizadosfonol = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    examenesRealizadosF: function () {
      this.e_realizados_ps();
      this.e_realizados_ps();
      this.e_realizados_fonol();
    },
    eliminarServicio: function (index) {
      this.arrayEspecialidad.splice(index, 1);
    },
    selectDataInformeEvolucion: function (fecha, terapeuta, tratamiento) {

      this.examenesPDF = [];
      this.motivoPDF = '';
      this.motivoPDF_id = 0;
      this.impresionesPDF = '';
      this.antecedentesPrePDF = [];
      this.antecedentesNeoPDF = [];
      this.antecedentesPosPDF = [];
      this.antecedentesPerPDF = [];
      this.antecedentesFamPDF = [];
      this.conclusionesPDF = [];
      this.recomendacionPDF = [];

      this.terapeutaPDF = terapeuta;

      let motivos = this.arrayMotivo;
      let impresiones = this.arrayResumen;
      let examenes = this.examenes_t;

      let motivoPDF = motivos.filter(motivo => motivo.MotFec == fecha && motivo.MotTer == terapeuta);
      // console.log('motivo consulta del informe', motivoPDF);
      this.motivoPDF = motivoPDF[0].MotVer;
      this.motivoPDF_id = motivoPDF[0].MotIde;
      console.log('id_pfd_motivo', this.motivoPDF_id);


      let examenesPDF = examenes.filter(examen => examen.created_at.substring(0,10) == fecha);
      this.examenesPDF = examenesPDF;
      var impresionesPDF = impresiones.filter(
        (impresion) =>
          impresion.ResFec == fecha && impresion.terapeuta == terapeuta
      );

      if(impresionesPDF.length>0){
        this.impresionesPDF = impresionesPDF[0].ResDes;
      }
      this.antecedentesPrePDF = this.convertArrayToText(
        this.antecedentesPre,
        "AntDes"
      );
      this.antecedentesNeoPDF = this.convertArrayToText(
        this.antecedentesNeo,
        "AntDes"
      );
      this.antecedentesPosPDF = this.convertArrayToText(
        this.antecedentesPos,
        "AntDes"
      );
      this.antecedentesPerPDF = this.convertArrayToText(
        this.antecedentesPer,
        "AntDes"
      );
      this.antecedentesFamPDF = this.convertArrayToText(
        this.antecedentesFam,
        "AntDes"
      );
      this.conclusionesPDF = tratamiento;
      this.fechaPDF = fecha;
    },
    convertArrayToText: function (data, propiedad, option = 1) {
      let texto = "";
      let prop = propiedad;
      if (propiedad != "") {
        for (let i = 0; i < data.length; i++) {
          texto = texto + ` ${data[i][propiedad]},`;
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          texto = texto + ` ${data[i]},`;
        }
      }

      if (option == 1) {
        return this.eliminarUltimoCaracter(texto);
      } else {
        return texto;
      }
    },
    eliminarUltimoCaracter: function (texto) {
      return texto.substring(0, texto.length - 1);
    },
    alerta() {
      let opcion = confirm(
        `¿desea continuar viendo la historia clinica de ${localStorage.getItem(
          "PacienteNombre"
        )}?`
      );
      if (opcion == true) {
        this.criterio = "PacNumDoc";
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC");
        localStorage.removeItem("PacienteId");
        localStorage.removeItem("PacienteNombre");
      }
    },
    push(route) {
      this.$router.push(route);
    },
    validarDispositivo: function () {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // console.log("Esto es un dispositivo móvil", navigator.userAgent);
        this.push("historia-movil");
      }
    },
  },

  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.motivosM();
      this.calcularFechaActual();
      this.usuarioAvanza = localStorage.getItem("usuario");
      if (localStorage.getItem("PacienteHC")) {
        this.alerta();
      }
      this.abrirModalVerificarFirma()

      this.validarDispositivo();
    }
  },
};
</script>
<style  scoped>



.card {
  border-radius: 10px;
}

.ti-eye {
  font-size: 20px !important;
  color: purple !important;
}

.fa-file {
  font-size: 37px !important;
}
.fa-backward {
  font-size: 37px !important;
}

.texto-pequeno {
  font-size: 12px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}
.titulo-modal {
  padding: 0px !important;
  margin: 0px !important;
}

.fa-check {
  font-size: 37px !important;
}

.texto_rojo {
  color: red !important;
}

.texto_verde {
  color: green !important;
  /* font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; */
}

.scroll-gg {
  width: 100%;
  height: 400px;
  overflow: auto;
}

.scroll {
  height: 500px;
  overflow: scroll;
}

.btn-warning {
  border-radius: 5px;
}

small {
  color: grey;
}

button {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Historia Clinica/historia-clinica.vue